import { ICON__circle_solid } from '@/assets/icons_fa';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_network, use_slice_ui } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { service_socketio_client } from '@/services/socketio_client_react/service_socketio_client';
import { set_interval } from '@/utils/utils_client';
import { string_to_span } from '@/utils/utils_html';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { timestamp_ms } from '@shared/utils/utils_time';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__tooltip } from '../../../components/ui/UI_PRIMITIVE__tooltip';
import { ENetworkQuality } from './e_network_quality';

export function HARDWARE_STATS__network_quality() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { avg_server_latency } = use_slice_network(['avg_server_latency']);
  const { global_need_show_first_animation } = use_slice_ui(['global_need_show_first_animation']);

  const tooltip = useMemo(() => get_tootlip(), [avg_server_latency]);
  const color = useMemo(() => get_color(), [avg_server_latency]);

  /*
   * EFFECTS
   */

  use_effect(() => {
    let interval_id = set_interval(try_ping_server, CONSTANTS_TIME__client.INTERVAL_PING);

    return () => clearInterval(interval_id);
  }, []);

  /*
   * METHODS
   */

  async function try_ping_server() {
    if (!service_socketio_client.socket) return;
    if (!service_socketio_client.socket?.connected) return;

    const timestamp = timestamp_ms();
    await send_to_server(ENUM__network_event_client_to_server.PING, timestamp);
  }

  function get_tootlip() {
    let status = '';

    if (avg_server_latency <= 100) {
      status = ENetworkQuality.EXCELLENT;
    } else if (avg_server_latency <= 1_000) {
      status = ENetworkQuality.GOOD;
    } else if (avg_server_latency <= 2_000) {
      status = ENetworkQuality.OK;
    } else {
      status = ENetworkQuality.BAD;
    }

    const i18n_status = t(i18n_base_ui.sidebar_navigation.network_quality.tooltip.status[status]);

    return t(i18n_base_ui.sidebar_navigation.network_quality.tooltip.title, { status: i18n_status, time: avg_server_latency });
  }

  function get_color() {
    let out = '';

    if (avg_server_latency <= 100) {
      out = '!text-green-700';
    } else if (avg_server_latency <= 1_000) {
      out = '!text-green-700';
    } else if (avg_server_latency <= 2_000) {
      out = '!text-orange-400';
    } else {
      out = '!text-red-600';
    }

    return out;
  }

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={string_to_span(tooltip)} side="right" delay_duration={0}>
      <div
        className={`flex-1 h-full flex flex-center hover-animation 
          ${global_need_show_first_animation ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}
      >
        <ICON__circle_solid className={`!w-2 !h-2 ${color}`} />
      </div>
    </UI_PRIMITIVE__tooltip>
  );
}
